<button
  [type]="buttonType"
  nz-button
  [nzType]="type"
  [disabled]="disabled"
  [nzLoading]="loading"
  [nzShape]="shape"
  [nzSize]="size"
  [nzDanger]="danger"
  (click)="onBtnClick()"
  [ngStyle]="{
    'width': customMinWidth ? 'unset' : customWidth,
    'min-width': customMinWidth,
  }"
  [ngClass]="{
    'width-inline': widthType === 'inline', 
    'width-inline-responsive': widthType === 'inline-responsive', 
    'width-responsive': widthType === 'responsive',
    'width-100': widthType === 'width-100',
    'width-100-inline-desktop': widthType === '100-inline-desktop',
    'width-100-inline-lg-desktop': widthType === '100-inline-lg-desktop',
  }"
  [attr.data-cy]="dataCy"
>
  <span #contentWrapper>
    <ng-content></ng-content>
  </span>
  @if (!hasContent) {
    <span>{{ label }}</span>
  }
</button>
